<script>
	import { navigate } from "svelte-navigator";
	import model from "../stores/modelStore";
	import { pageNumber, currentPage } from "../stores/pageStore";

	export let disableNextButton = null;
	export let disablePreviousButton = null;

	export let handlePrevious = () => true;

	let previousSpinnerClassName = null;
	let nextSpinnerClassName = null;
	let nextBtnDisabled = disableNextButton;
	let previousBtnDisabled = disablePreviousButton;


	export const buttons = {

		unblock() {
			nextSpinnerClassName = previousSpinnerClassName = null;
			nextBtnDisabled = null;
			previousBtnDisabled = null;
		},

		blockNext() {
			nextSpinnerClassName = "spinner-border spinner-border-sm";
			nextBtnDisabled = true;
			previousBtnDisabled = true;
		},

		blockPrevious() {
			previousSpinnerClassName = "spinner-border spinner-border-sm";
			nextBtnDisabled = true;
			previousBtnDisabled = true;
		},

		next() {
			let nextPage = $currentPage.nextPage;
			if (typeof $currentPage.nextPage === "function") {
				nextPage = $currentPage.nextPage($model);
			}
			navigate(nextPage);

			if(!$currentPage.endSurvey) {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		},
		
		previous() {
			buttons.blockPrevious();
			if (handlePrevious()) {
				let previousPage = $currentPage.previousPage;
				if (typeof previousPage === "function") {
					previousPage = $currentPage.previousPage($model);
				}

				navigate(previousPage);
			}
			buttons.unblock();
		},

	}

</script>

<div
	class="btn-wrap {$$props.class}"
	class:single={!$currentPage.previousPage || !$currentPage.nextPage}
>
	{#if $currentPage.previousPage}
		<button
			class="btn btn-primary btn-page-nav"
			aria-label="Previous Page"
			type="button"
			disabled={previousBtnDisabled || disablePreviousButton}
			on:click|preventDefault={buttons.previous}
		>
			<span
				class={previousSpinnerClassName}
				role="status"
				aria-hidden="true"
			/>
			{ $currentPage.previousLabel || "Previous" }
		</button>
	{/if}
	{#if $currentPage.nextPage}
		<button
			class="btn btn-primary btn-page-nav"
			aria-label="Next Page"
			disabled={nextBtnDisabled || disableNextButton}
			type="submit"
		>
			<span
				class={nextSpinnerClassName}
				role="status"
				aria-hidden="true"
			/>
			{ $currentPage.nextLabel || "Next" }
		</button>
	{/if}
</div>

<style>
	.btn-wrap {
		display: flex;
		justify-content: space-between;
	}

	.btn-wrap .btn {
		width: 48%;
	}

	.btn-wrap.single {
		display: flex;
		justify-content: center;
	}

	.btn-page-nav {
		min-width: 143px;
	}

	.btn-wrap.single .btn {
		width: 100%;
	}

	@media (min-width: 768px) {
		.btn-page-nav {
			min-width: 191px;
		}

		.btn-wrap {
			display: block;
		}

		.btn-wrap .btn {
			width: auto;
		}

		.btn-wrap.single .btn {
			width: auto;
		}
	}
</style>
